import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "project-full-history rounded mb-5" }
const _hoisted_2 = { class: "team-info-tab-row align-items-baseline d-flex" }
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = { class: "team-info-body mt-3" }
const _hoisted_5 = { class: "team-info-body-content" }
const _hoisted_6 = {
  id: "project-history-list",
  class: "w-100 small project-history list-group"
}
const _hoisted_7 = {
  key: 0,
  class: "list-group-item list-group-item-action list-group-item-load-more"
}
const _hoisted_8 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_version_item = _resolveComponent("version-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("h4", null, "Full Project History")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.project.name), 1),
      _createElementVNode("button", {
        class: "btn btn-attention btn-back-to-projects",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeFullHistory()))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1),
        _createTextVNode(" All Projects ", -1)
      ]))])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versions, (v) => {
            return (_openBlock(), _createBlock(_component_version_item, _mergeProps({
              key: v.number
            }, { ref_for: true }, {'data-version': v.number}, {
              version: v,
              project: _ctx.project,
              glasspane: _ctx.toggleGlasspane
            }), null, 16, ["version", "project", "glasspane"]))
          }), 128)),
          (_ctx.showMoreVersionsButton())
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    id: "more-versions",
                    class: _normalizeClass(["btn btn-sm btn-secondary", { 'd-none': !_ctx.showMoreVersionsButton() }]),
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadMoreVersions && _ctx.loadMoreVersions(...args)))
                  }, "Load more", 2)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}